<template>
  <ul
    class="sb-products--grid"
    :class="[
      currentPanelSize == 2 ? 'medium' : '',
      currentPanelSize == 1 ? 'small' : '',
    ]"
    v-infinite-scroll="mobileNext"
    infinite-scroll-distance="5"
    infinite-scroll-disabled="stopInfiniteLoad"
    infinite-scroll-throttle-delay="800"
    infinite-scroll-immediate-check="false"
  >
    <template v-if="products.length > 0 && isLoading == false">
      <span
        :class="controls && collectionPage > 1 ? '' : 'sb-disabled'"
        class="sb-product-controls sb-prev"
        @click="prev"
        >&#8249;</span
      >

      <sb-product v-for="(p, i) in currentProducts" :product="p" :key="i">
      </sb-product>

      <div
        class="lastPageWarning"
        v-if="
          (currentProducts.length < currentPanelSize && currentPanelSize > 1) ||
          (stopInfiniteLoad && isMobile())
        "
        :class="
          (currentProducts.length == 2 ? 'lastPageWarningHalf' : '',
          collectionPage > 1 ? '' : 'sb-first-page')
        "
      >
        <span v-html="content[lang].errors.last">
          <!-- You have reached the last page <b class="emoji">🤷‍♂️</b> <br />
          Go back to review previous -->
        </span>
      </div>
      <span
        :class="
          controls && currentProducts.length >= currentPanelSize
            ? ''
            : 'sb-disabled'
        "
        class="sb-product-controls sb-next"
        @click="next"
        >&#8250;</span
      >
      <div
        v-if="nextLoaderMobile && stopInfiniteLoad == false"
        class="lds-ellipsis"
      >
        <div></div>
        <div></div>
        <div></div>
      </div>
    </template>

    <div v-else class="sb-not--found">
      <p v-if="!isLoading && !nextLoaderMobile" v-html="errorMessage"></p>
      <template v-else>
        <sb-loader
          v-if="isMobile() == false || collectionPage == 1"
        ></sb-loader>
      </template>
    </div>
  </ul>
</template>

<script>
import sbProduct from "./Product.vue";
import sbLoader from "./Loader.vue";
import { mapState } from "vuex";

export default {
  props: {
    products: {
      type: Array,
    },
    controls: {
      type: Boolean,
      default: true,
    },
    collectionPage: {
      type: Number,
    },

    width: String,
    height: String,
    collection: String,
    errorMessage: String,
    productbannerbody: String,
    productbannerbtn: String,
    productbannerlink: String,
  },

  computed: {
    ...mapState([
      "isLoading",
      "lastProductId",
      "currentPanelSize",
      "nextLoaderMobile",
      "stopInfiniteLoad",
      "productBannerData",
      "client",
      "brand",
      "content",
      "lang",
    ]),
    currentProducts: function () {
      if (this.isMobile()) {
        return this.products;
      } else {
        let paginatedProducts = this.products.slice(
          (this.collectionPage - 1) * this.currentPanelSize,
          this.collectionPage * this.currentPanelSize
        );
        if (
          this.collectionPage == 2 &&
          (this.productBannerData || this.client == "mcmahons")
        ) {
          if (this.client == "mcmahons") {
            if (this.brand) {
              if (this.brand == "sonas") {
                paginatedProducts[1] = {
                  text: "Do you know you can book a private consultation or discuss your project with our expects?",
                  btns: [
                    {
                      text: "Book a Consultation (Limerick)",
                      link: "https://www.mcmahons.ie/consultation-bathroom-experts",
                    },
                    {
                      text: "Call our Bathroom Experts",
                      link: "https://www.mcmahons.ie/plumbing-and-heating",
                    },
                  ],
                };
              } else if (this.brand == "millboard") {
                paginatedProducts[1] = {
                  text: "See for yourself the outstanding quality and authentic wood look of Millboard decking.",
                  btns: [
                    {
                      text: "Order a Sample",
                      link: "https://www.mcmahons.ie/garden-landscaping/decking/millboard",
                    },
                    {
                      text: "Request a Quote",
                      link: "https://www.mcmahons.ie/millboard-decking",
                    },
                  ],
                };
              } else {
                paginatedProducts[1] = {
                  text: "We are here for you to discuss pricing, delivery, availability or opening hours.",
                  btns: [
                    {
                      text: "Your Local Branch",
                      link: "https://www.mcmahons.ie/store-locator",
                    },
                    {
                      text: "Request a Quote",
                      link: "https://www.mcmahons.ie/request-quote",
                    },
                  ],
                };
              }
            } else {
              paginatedProducts[1] = {
                text: "We are here for you to discuss pricing, delivery, availability or opening hours.",
                btns: [
                  {
                    text: "Your Local Branch",
                    link: "https://www.mcmahons.ie/store-locator",
                  },
                  {
                    text: "Request a Quote",
                    link: "https://www.mcmahons.ie/request-quote",
                  },
                ],
              };
            }
          } else {
            paginatedProducts[1] = {
              text: this.productBannerData.text,
              btns: this.productBannerData.btns,
            };
          }
        }

        return paginatedProducts;
      }
    },
  },
  components: {
    sbProduct,
    sbLoader,
  },
  data() {
    return {};
  },

  methods: {
    prev() {
      this.$store.commit("PRODUCTS_PREV", {
        collection: this.collection,
      });
    },
    mobileNext() {
      if (this.isMobile()) {
        this.next();
      }
    },
    next() {
      let len = this.products.length;
      let tour = window.dndTour;
      if (tour && tour.isActive()) {
        tour.complete();
      }
      if (
        this.collectionPage >= Math.ceil(len / 3) ||
        (this.stopInfiniteLoad == false && this.isMobile())
      ) {
        this.$emit("toggleProducts", {
          sku: this.lastProductId,
          page: this.collectionPage + 1,
          reset: false,
          force: true,
          toggle: true,
        });
      }
      if (!this.isMobile()) {
        this.$store.commit("PRODUCTS_NEXT", {
          collection: this.collection,
        });
      } else {
        if (this.stopInfiniteLoad == false) {
          this.$store.commit("PRODUCTS_NEXT", {
            collection: this.collection,
          });
        }
      }
    },
  },
};
</script>

<style scoped>
#shopbox .sb-products--grid {
  display: flex;
  align-items: flex-end;
  justify-items: flex-start;
  margin: 0px auto;
  width: calc(100% - 8px);
  height: 250px;
  padding: 4px;
  list-style: none;
  position: relative;
}
#shopbox .shopbox-portrait .sb-products--grid {
  height: 320px;
}
#shopbox .small .sb-not--found,
#shopbox .medium .sb-not--found {
  overflow: hidden;
}
#shopbox .small .item,
#shopbox .medium .item {
  display: none;
}
#shopbox .small .item:first-of-type {
  display: flex;
  width: 100%;
  flex-basis: 100%;
}
#shopbox .medium .item:first-of-type,
#shopbox .medium .item:nth-of-type(2) {
  display: flex;
  width: 100%;
  flex-basis: 100%;
}
#shopbox /deep/.small svg {
  transform: scaleY(3) scaleX(4.2);
}
#shopbox /deep/ .medium svg {
  transform: scaleY(1.24) scaleX(1.56);
}

#shopbox .sb-not--found {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  width: 100%;
}
#shopbox .sb-not--found p {
  font-size: 1.3em;
}
#shopbox .sb-product-controls {
  position: absolute;
  top: 50%;
  border-radius: 6px;
  background: var(--shopbox-text-light);
  width: 32px;
  height: 64px;
  box-shadow: 0 1px 4px 0 rgba(117, 141, 166, 0.3142);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  font-size: 38px;
  line-height: 16px;
  font-family: monospace !important;
  padding-bottom: 6px !important;
}
#shopbox .sb-next {
  right: -10px;
  transform: translateY(-50%) translateX(50%);
}
#shopbox .sb-prev {
  left: -10px;
  transform: translateY(-50%) translateX(-50%);
}
#shopbox .sb-product-controls.sb-disabled {
  cursor: not-allowed;
  pointer-events: none;
  filter: brightness(92%);
}

#shopbox .lastPageWarning.sb-first-page {
  line-height: 36px;
}
#shopbox .lastPageWarning.sb-first-page > span {
  height: 44px;
  overflow: hidden;
}
#shopbox .lastPageWarning {
  font-size: 18px;
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
}
#shopbox .lastPageWarning.lastPageWarningHalf {
  width: 50%;
}
#shopbox .lastPageWarning .emoji {
  font-size: 24px;
  line-height: 18px;
}
@media (max-width: 640px) {
  #shopbox .lastPageWarning {
    height: auto;
  }
}

#shopbox .lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 20px;
}
#shopbox .lds-ellipsis div {
  position: absolute;
  top: 0px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: var(--shopbox-background-dark);
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
#shopbox .lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
#shopbox .lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
#shopbox .lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
#shopbox.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}
</style>
